export const isDescendant = (parent, child) => {
  let node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

export const htmlToPlainText = (html) => {
  if (html) {
    return html.replace(/<\/?[^>]+(>|$)/g, ' ');
  }
  return '';
};
